import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ShipmentDestination {
  code: string;
  message?: string;
  shipment_list_uuid?: string;
  consignee?: {
    contact_uuid: string;
    contact_organization?: string;
  };
  consignee_address?: {
    contact_address_uuid: string;
    address_street?: string;
    address_locality?: string;
    address_region?: string;
    address_postal_code?: string;
    address_country?: string;
  };
}

@Injectable({ providedIn: 'root' })
export class ShipmentDestinationService {
  constructor(private http: HttpClient) {}

  currentPoolStoreDestination(shipmentUuid: string): Observable<ShipmentDestination> {
    return this.http.get<ShipmentDestination>('/api/shipment_lists/shipment_details.php', {
      params: { uuid: shipmentUuid, command: 'CURRENT_POOL_STORE_DESTINATION' },
    });
  }
}
